var _rect, _rect2, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGeneralTaskLight = function SvgGeneralTaskLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "#D0EED8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#328847"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4887 20.7647H16.6471V16.6471H20.7647V9.4887C20.7647 9.41479 20.741 9.35407 20.6934 9.30655C20.6459 9.25904 20.5852 9.23528 20.5113 9.23528H9.4887C9.41479 9.23528 9.35407 9.25904 9.30655 9.30655C9.25904 9.35407 9.23528 9.41479 9.23528 9.4887V20.5113C9.23528 20.5852 9.25904 20.6459 9.30655 20.6934C9.35407 20.741 9.41479 20.7647 9.4887 20.7647ZM9.4887 22C9.07799 22 8.7272 21.8546 8.43633 21.5637C8.14544 21.2728 8 20.922 8 20.5113V9.4887C8 9.07799 8.14544 8.7272 8.43633 8.43633C8.7272 8.14544 9.07799 8 9.4887 8H20.5113C20.922 8 21.2728 8.14544 21.5637 8.43633C21.8546 8.7272 22 9.07799 22 9.4887V17.1776L17.1776 22H9.4887ZM11.2466 16.4253V15.1901H15V16.4253H11.2466ZM11.2466 13.147V11.9118H18.7534V13.147H11.2466Z",
    fill: "#328847"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGeneralTaskLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/general-task-light.a7e2d685.svg";
export { ForwardRef as ReactComponent };